import { render, staticRenderFns } from "./Taxonomy.vue?vue&type=template&id=74a2e356&"
import script from "./Taxonomy.vue?vue&type=script&lang=js&"
export * from "./Taxonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports